// Centralized API Configuration
export const API_CONFIG = {
  // Retry settings
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY_BASE: 1000, // Base delay in milliseconds
  
  // Timeout settings
  TIMEOUT: 10000, // 10 seconds
  
  // Cache settings
  CACHE_TTL: 5 * 60 * 1000, // 5 minutes
  
  // Debug settings
  DEBUG: import.meta.env.DEV,
  VERBOSE_LOGGING: import.meta.env.DEV,
  
  // Performance monitoring
  ENABLE_PERFORMANCE_MONITORING: import.meta.env.DEV,
  PERFORMANCE_THRESHOLD: 2000, // Log if operation takes more than 2 seconds
  
  // Error tracking
  ENABLE_ERROR_TRACKING: true,
  ERROR_SAMPLE_RATE: import.meta.env.PROD ? 0.1 : 1.0, // 10% in prod, 100% in dev
  
  // Subscription specific
  SUBSCRIPTION_REFRESH_INTERVAL: import.meta.env.PROD ? 30 * 1000 : null, // 30 seconds in prod, disabled in dev
  CREDIT_WARNING_THRESHOLD: 50, // Warn when credits below this amount
  EXPIRY_WARNING_DAYS: 7, // Warn when subscription expires within this many days
}

// Environment validation
export const validateEnvironment = () => {
  const required = [
    'VITE_SUPABASE_URL',
    'VITE_SUPABASE_ANON_KEY'
  ]
  
  const missing = required.filter(key => !import.meta.env[key])
  
  if (missing.length > 0) {
    throw new Error(`Missing required environment variables: ${missing.join(', ')}`)
  }
  
  // Validate URLs
  try {
    new URL(import.meta.env.VITE_SUPABASE_URL)
  } catch (error) {
    throw new Error('Invalid VITE_SUPABASE_URL format')
  }
  
  console.log('✅ Environment validation passed')
}

// API endpoints configuration
export const API_ENDPOINTS = {
  SUBSCRIPTION_PACKAGES: 'subscription_packages',
  USER_SUBSCRIPTIONS: 'user_subscriptions',
  SUBSCRIPTION_TRANSACTIONS: 'subscription_transactions',
  CREDIT_USAGE_LOG: 'credit_usage_log'
}

// Error codes mapping
export const ERROR_CODES = {
  PGRST116: 'NO_ROWS_FOUND',
  PGRST301: 'PERMISSION_DENIED',
  PGRST204: 'SCHEMA_CACHE_STALE',
  '23505': 'UNIQUE_VIOLATION',
  '23503': 'FOREIGN_KEY_VIOLATION'
}

// Default export
export default API_CONFIG